var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrk lis"},[_c('img',{staticClass:"ims",attrs:{"src":"img/lxwmE-2.jpg"}}),_c('BaiduMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }